import { useEffect, useState } from "react";
import { GetTodayPunchTime } from "../AttendanceApis";

const formatTime = (raw) => {
    if (!raw) return "—";
    const d = new Date(raw);
    if (isNaN(d)) return raw;
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    const hours = String(d.getHours()).padStart(2, "0");
    const minutes = String(d.getMinutes()).padStart(2, "0");
    const seconds = String(d.getSeconds()).padStart(2, "0");
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
};

const AttendancePunchHistoryTable = ({
    row,
    subThStyle,
    subTdStyle,
    onHistoryLoaded,
}) => {
    const [punches, setPunches] = useState([]);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchPunches = async () => {
            if (!row?.employeeId) {
                setPunches([]);
                onHistoryLoaded?.(row, []);
                return;
            }

            setLoading(true);
            try {
                const response = await GetTodayPunchTime(row.employeeId);
                const history = response?.data ?? [];
                setPunches(history);
                onHistoryLoaded?.(row, history);
            } catch (error) {
                console.error("Punch fetch error:", error);
                setPunches([]);
                onHistoryLoaded?.(row, []);
            } finally {
                setLoading(false);
            }
        };

        fetchPunches();
    }, [row]);

    if (loading) {
        return (
            <span style={{ fontSize: "12px", color: "#6b7280" }}>
                Loading punch records...
            </span>
        );
    }

    if (!punches.length) {
        return (
            <span style={{ fontSize: "12px", color: "#9ca3af" }}>
                No punch records found.
            </span>
        );
    }

    return (
        <div style={{ overflowX: "auto" }}>
            <table
                style={{
                    width: "100%",
                    maxWidth: 900,
                    borderCollapse: "collapse",
                    textAlign: "center",
                    fontSize: "13px",
                }}
            >
                <thead>
                    <tr>
                        <th style={subThStyle}>S.No</th>
                        <th style={subThStyle}>Emp Code</th>
                        <th style={subThStyle}>Punch Time</th>
                    </tr>
                </thead>
                <tbody>
                    {punches.map((punch, index) => (
                        <tr key={`${punch.empCode ?? "punch"}-${index}`}>
                            <td style={subTdStyle}>{punch.sNo ?? index + 1}</td>
                            <td style={subTdStyle}>{punch.empCode ?? "—"}</td>
                            <td style={subTdStyle}>{formatTime(punch.punchTime)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AttendancePunchHistoryTable;
